import React, { useEffect, useMemo, useState } from 'react'
import { Button } from 'antd'

import Styles from './apply-field-rule-tree.module.scss'
import ApplyFieldSubRuleGroup, { createEmptySubRuleGroup } from './ApplyFieldSubRuleGroup'
import { generateApplyFieldRuleDescription } from './generateApplyFieldRuleDescription'

function ApplyFieldRuleItem (props) {
  const [subRuleList, setSubRuleList] = useState(props.ruleItem.children || [])

  useEffect(() => {
    setSubRuleList(props.ruleItem.children || [])
  }, [props.ruleItem])

  const syncSubRules = (list) => {
    props.ruleItem.children = list
    setSubRuleList([...list])
    props.ruleUpdate?.()
  }

  const addSubRuleGroup = () => {
    syncSubRules([...(props.ruleItem.children || []), createEmptySubRuleGroup()])
  }

  const deleteSubRuleGroup = (groupCode) => {
    syncSubRules((props.ruleItem.children || []).filter(item => item.code !== groupCode))
  }

  const ruleDescription = useMemo(() => {
    return generateApplyFieldRuleDescription({
      ...props.ruleItem,
      children: subRuleList
    })
  }, [props.ruleItem, subRuleList])

  return (
    <div className={ Styles.ruleItem }>
      <div className={ Styles.ruleItemHeader }>
        <div>规则字段：{ props.ruleItem.formData?.fieldName }</div>
        {
          !props.disabled && (
            <div>
              <Button
                className="mr-2"
                type="primary"
                size="small"
                ghost
                onClick={ addSubRuleGroup }
              >添加子规则</Button>
              <Button
                type="primary"
                size="small"
                ghost
                danger
                onClick={ () => props.deleteRuleItem?.(props.ruleItem) }
              >删除</Button>
            </div>
          )
        }
      </div>
      <div className={ Styles.ruleItemBody }>
        {
          subRuleList.length === 0 ? (
            <div className={ Styles.subRuleEmpty }>
              暂无子规则，点击「添加子规则」开始配置
            </div>
          ) : (
            <div className={ Styles.subRuleList }>
              {
                subRuleList.map((subRuleGroup, index) => {
                  return (
                    <ApplyFieldSubRuleGroup
                      key={ subRuleGroup.code }
                      subRuleGroup={ subRuleGroup }
                      showGroupRelation={ index > 0 }
                      availableFields={ props.availableFields }
                      disabled={ props.disabled }
                      onDeleteGroup={ () => deleteSubRuleGroup(subRuleGroup.code) }
                      onChange={ props.ruleUpdate }
                    ></ApplyFieldSubRuleGroup>
                  )
                })
              }
            </div>
          )
        }
      </div>
      {
        ruleDescription && (
          <div className={ Styles.ruleItemFooter }>
            <span className={ Styles.ruleItemFooterLabel }>规则说明：</span>
            <span className={ Styles.ruleItemFooterText }>{ ruleDescription }</span>
          </div>
        )
      }
    </div>
  )
}

export default ApplyFieldRuleItem
